module.exports = __webpack_public_path__ + "img/iota.3f0f52d3.svg";